<template>
  <main class="l-main p-search-volume">
    <TitleMain icon="searchvolume" howTo="/sections/4404631667855">
      <span class="title">検索ボリューム調査</span>
      <span class="description">
        対象キーワードの月間検索数を表示します。<br />コンテンツを検討する際の簡単な調査ができます。
      </span>
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Breadcrumb />
      </div>
      <FormAddKeyword
        :project="project"
        :isProcessing="isProcessing"
        :hasError="hasError"
        @submit="submit"
      />
      <div
        v-if="!data.items.length && !isLoading"
        class="p-search-volume-nodata l-block"
      >
        <div class="p-search-volume-nodata__content">
          <p>
            検索ボリュームを調べて、キーワード調査をしてみよう。<br />調査結果はCSV形式でダウンロードできます。
          </p>
        </div>
      </div>
      <div v-else class="p-search-volume-result l-block">
        <div class="l-block__content">
          <div class="l-block__header">
            <TitleSub level="h3">
              <div class="c-image--radius l-mr-2">
                <img
                  src="@/assets/img/img-chara-search.svg"
                  alt=""
                  width="38"
                />
              </div>
              指定したキーワード
            </TitleSub>
            <ButtonDownload :items="data.items" />
          </div>
          <ListKeyword :items="data.items" :isLoading="isLoading" />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import ButtonToProjects from '@/components/ButtonToProjects';
import ButtonDownload from '@/components/searchVolume/ButtonDownload';
import FormAddKeyword from '@/components/searchVolume/FormAddKeyword';
import ListKeyword from '@/components/searchVolume/ListKeyword';
import TitleMain from '@/components/TitleMain';
import TitleSub from '@/components/TitleSub';
import apiSearchVolumes from '@/api/search-volumes';

export default {
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Breadcrumb,
    ButtonToProjects,
    ButtonDownload,
    FormAddKeyword,
    ListKeyword,
    TitleMain,
    TitleSub
  },
  data() {
    return {
      data: {
        items: []
      },
      hasError: false,
      isLoading: false,
      isProcessing: false
    };
  },
  watch: {
    hasError: {
      // エラーメッセージを消すのに丁度いいトリガーがないので、3秒後に消すようにする
      handler(value) {
        if (!value) {
          return;
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.hasError = false;
          }, 3000);
        });
      }
    }
  },
  methods: {
    submit(keywords) {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;
      this.isLoading = true;

      const param = {
        keywords: keywords
      };

      apiSearchVolumes
        .post(param, this.auth.idToken)
        .then(response => {
          this.data.items = response.data.items;
        })
        // エラーが発生した場合、失敗したことをユーザーに伝える
        .catch(error => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
          this.isProcessing = false;
        });
    }
  }
};
</script>
